import { observable } from 'mobx';
import { BaseStore } from '~web/store/base/base-store';
import { MarketplaceClosedAlertParameters } from '~web/view/pages/parameters';

/**
 * Possible actions on Discover page
 */
export enum EventPageAction {
  MARKETPLACE_CLOSED_ALERT,
}

/**
 * Possible parameters for the actions on Discover page
 */
interface EventPageParameters extends MarketplaceClosedAlertParameters {}

export class EventPageActionStore extends BaseStore {
  @observable pageAction: EventPageAction;
  parameters: EventPageParameters;

  constructor() {
    super();
    this.clear();
  }

  initialize(pageAction: EventPageAction, parameters?: EventPageParameters): void {
    this.pageAction = pageAction;
    this.parameters = parameters;
  }

  clear(): void {
    this.pageAction = undefined;
    this.parameters = undefined;
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/web/src/js/store/event/event-page-action-store.ts